export class OverlappingMultipleStopAreaVersions extends Error {}
